/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-04-14 10:34:05
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-04-14 10:35:31
 * @FilePath: \lowsky\src\data\resources.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import bannerImage from '@/assets/banner.jpg'

export const lowAltitudeResources = [
  {
    id: 1,
    title: '无人机航拍服务',
    description: '专业无人机航拍，提供高空视角摄影摄像服务',
    tags: ['航拍', '摄影', '视频'],
    image: bannerImage,
    category: '服务',
    phone: '138****1234',
    company: 'XX航拍科技有限公司',
    nickname: '张航拍',
    location: '北京市朝阳区'
  },
  {
    id: 2,
    title: '低空遥感技术',
    description: '基于低空平台的遥感数据采集与分析',
    tags: ['遥感', '测绘', '数据分析'],
    image: bannerImage,
    category: '技术',
    phone: '159****5678',
    company: '遥感数据科技有限公司',
    nickname: '李遥感',
    location: '上海市浦东新区'
  },
  {
    id: 3,
    title: '农业植保无人机',
    description: '智能农业植保解决方案，高效农药喷洒',
    tags: ['农业', '植保', '智能'],
    image: bannerImage,
    category: '农业',
    phone: '135****9012',
    company: '智慧农业科技有限公司',
    nickname: '王植保',
    location: '成都市高新区'
  },
  {
    id: 4,
    title: '低空物流配送',
    description: '无人机物流配送服务，快速高效',
    tags: ['物流', '配送', '快递'],
    image: bannerImage,
    category: '物流',
    phone: '137****3456',
    company: '极速物流科技有限公司',
    nickname: '刘配送',
    location: '广州市天河区'
  },
  {
    id: 5,
    title: '应急救援无人机',
    description: '灾害应急响应和救援支持',
    tags: ['应急', '救援', '安全'],
    image: bannerImage,
    category: '应急',
    phone: '139****7890',
    company: '应急救援科技有限公司',
    nickname: '陈救援',
    location: '深圳市南山区'
  },
  {
    id: 6,
    title: '环境监测系统',
    description: '空气质量、水质等环境监测服务',
    tags: ['环保', '监测', '检测'],
    image: bannerImage,
    category: '环保',
    phone: '136****2345',
    company: '绿色环境科技有限公司',
    nickname: '赵监测',
    location: '杭州市西湖区'
  },
  {
    id: 7,
    title: '电力巡检服务',
    description: '高压线路无人机巡检，安全高效',
    tags: ['电力', '巡检', '维护'],
    image: bannerImage,
    category: '能源',
    phone: '134****6789',
    company: '电能巡检科技有限公司',
    nickname: '孙巡检',
    location: '武汉市江汉区'
  },
  {
    id: 8,
    title: '地理信息系统',
    description: '基于低空平台的地理信息采集与建模',
    tags: ['GIS', '测绘', '建模'],
    image: bannerImage,
    category: '技术',
    phone: '132****8901',
    company: '空间信息科技有限公司',
    nickname: '周建模',
    location: '南京市鼓楼区'
  }
]
